var _g, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 562,
    height: 831,
    viewBox: "0 0 562 831",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8827_3458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.999 823L35.5 406L521.5 413.5L281.999 823Z",
    fill: "#62ADEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558 277C558 429.983 433.983 554 281 554C128.017 554 4 429.983 4 277C4 124.017 128.017 0 281 0C433.983 0 558 124.017 558 277Z",
    fill: "#62ADEF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M205.07 493.998H241.087L259.702 442.266H223.684L205.07 493.998Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M302.298 442.266L320.914 493.998H356.93L338.316 442.266H302.298Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M370.901 175.094H349.299V164H212.702V175.094H191.099L178.069 188.124V416.136L191.099 429.165H370.901L383.931 416.136V188.124L370.901 175.094ZM227.57 181.114H334.43V192.014H227.57V181.114ZM204.469 233.001H357.533V325.746H204.469V233.001ZM253.389 391.422H204.304V359.706H253.389V391.422ZM357.697 391.422H308.611V359.706H357.697V391.422Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M235 458.5H319M235 485.5H319",
    stroke: "white",
    strokeWidth: 7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8827_3458",
    x: 0,
    y: 0,
    width: 562,
    height: 831,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8827_3458"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8827_3458",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubway);
export default __webpack_public_path__ + "static/media/subway.18ae3aead063f37f22e1a100b7476086.svg";
export { ForwardRef as ReactComponent };